import React from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { fmtPrice } from "../lib/api";
import { useCart } from "../context/CartContext";
import { handleImgError } from "../lib/imgFallback";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function QuickViewModal({ product, open, onOpenChange }) {
  const { addItem } = useCart();
  if (!product) return null;
  const low = typeof product.stock === "number" && product.stock <= 10;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="quickview-modal" className="bg-[#171717] border border-white/10 text-[#F5F5F5] max-w-3xl p-0 overflow-hidden gap-0">
        <div className="grid grid-cols-1 sm:grid-cols-2">
          <div className="aspect-square bg-[#0F0F10]">
            <img src={product.image} alt={product.name} onError={handleImgError} className="h-full w-full object-cover" />
          </div>
          <div className="p-8 flex flex-col">
            <span className="text-[10px] uppercase tracking-[0.2em] text-[#A8A8A8]">{product.category}</span>
            <DialogTitle className="mt-2 font-display text-2xl tracking-tight text-[#F5F5F5]">{product.name}</DialogTitle>
            <DialogDescription className="mt-1 text-[13px] text-[#4ADE80]">{product.tagline}</DialogDescription>
            <p className="mt-4 text-[14px] text-[#A8A8A8] font-light leading-relaxed line-clamp-4">{product.description}</p>
            <div className="mt-5 flex items-center gap-4 text-[12px] text-[#A8A8A8]">
              <span>{product.size}</span><span>·</span><span>{product.purity} purity</span>
            </div>
            {low && <p data-testid="quickview-stock" className="mt-3 text-[11px] uppercase tracking-[0.14em] text-[#4ADE80]">Only {product.stock} left</p>}
            <div className="mt-auto pt-6 flex items-center justify-between">
              <span className="font-display text-2xl">{fmtPrice(product.price)}</span>
            </div>
            <div className="mt-4 flex gap-3">
              <button data-testid="quickview-add-btn" onClick={() => { addItem(product, 1); toast.success(`${product.name} added`); }}
                className="btn-press flex-1 bg-[#4ADE80] text-[#0F0F10] uppercase tracking-[0.16em] text-[11px] py-3.5 hover:bg-[#6FE998]">Add to Cart</button>
              <Link to={`/products/${product.slug}`} onClick={() => onOpenChange(false)} data-testid="quickview-view-btn"
                className="btn-press border border-white/20 px-5 py-3.5 hover:border-[#4ADE80] hover:text-[#4ADE80] inline-flex items-center gap-2"><ArrowRight className="h-4 w-4" /></Link>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
